import { render, staticRenderFns } from "./ObjectExtras.vue?vue&type=template&id=a070834a&scoped=true&"
import script from "./ObjectExtras.vue?vue&type=script&lang=js&"
export * from "./ObjectExtras.vue?vue&type=script&lang=js&"
import style0 from "./ObjectExtras.vue?vue&type=style&index=0&id=a070834a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a070834a",
  null
  
)

export default component.exports